import { FC } from 'react';
import { LoaderType, NextgenImage, useTranslation } from '@nextgen-web-framework/all';
import { AssetPath } from '../../../utils/Constants';
import { ProductItemProps, ProductDisplayDirection } from './types/propTypes';
import styles from './ProductItem.module.scss';

const ProductItem: FC<ProductItemProps> = ({
  productName,
  productDescription,
  productImageUrl = AssetPath.STARTER_KIT_IMAGE,
  productQuantity,
  className,
  direction = ProductDisplayDirection.VERTICAL,
}) => {
  const t = useTranslation();

  const displayQty = () =>
    productQuantity && (
      <div className={`${styles['product-qty']} ${styles[direction.toLowerCase()]}`} data-testid="product-qty">
        {t('profile.AccountRenewal.selectKit.qty')} {productQuantity}
      </div>
    );

  return (
    <div className={`${styles['product-item']} ${className}`} data-testid="product-item">
      <div className={styles['product-item-img']}>
        <div className={styles['product-img']}>
          <NextgenImage
            src={`/${productImageUrl}`}
            isRelativeURL={true}
            loaderType={LoaderType.WEBFONTS}
            alt="product icon"
            fill={true}
          />
        </div>
      </div>
      <div className={styles['product-item-name']} data-testid="product-item-name">
        <div className={styles['product-name']}>{productName}</div>
        <div className={styles['product-desc']}>{productDescription}</div>
        {direction === ProductDisplayDirection.VERTICAL && displayQty()}
      </div>
      {direction === ProductDisplayDirection.HORIZONTAL && displayQty()}
    </div>
  );
};

export default ProductItem;
